import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
export interface DialogData {
  heading: string;
  content: string;
}

@Component({
  selector: 'app-dialog',
  templateUrl:'dialog.component.html'
})

export class OpenDialog {

  constructor(
    public dialogRef: MatDialogRef<OpenDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

  onClose(): void {
    this.dialogRef.close();
  }

}